import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { ITeamDetails } from '@shared/types';

// #region CONVERTERS *******************************************************************
export const teamDetailsToDoc = (team: ITeamDetails): DocumentData => {
  return {
    teamID: team.teamID,
    teamAbrv: team.teamAbrv,
    teamName: team.teamName,
    teamFullName: team.teamFullName,
    teamLogo: team.teamLogo,
    teamColor: team.teamColor,
    teamSecondaryColor: team.teamSecondaryColor,
    teamConference: team.teamConference,
    teamDivision: team.teamDivision,
    teamCity: team.teamCity,
    teamState: team.teamState,
    teamStadium: team.teamStadium,
    teamStadiumFieldType: team.teamStadiumFieldType ?? 'ArtificialTurf',
    teamStadiumHasRoof: team.teamStadiumHasRoof ?? false,
    teamCapacity: team.teamCapacity,
    teamHeadCoach: team.teamHeadCoach,
    teamOffensiveCoordinator: team.teamOffensiveCoordinator,
    teamDefensiveCoordinator: team.teamDefensiveCoordinator,
    teamSpecialTeamsCoach: team.teamSpecialTeamsCoach,
    teamOffensiveScheme: team.teamOffensiveScheme,
    teamDefensiveScheme: team.teamDefensiveScheme,
    teamBaseFormation: team.teamBaseFormation,
    teamBaseDefense: team.teamBaseDefense,
    teamBaseOffense: team.teamBaseOffense,
    teamBaseSpecialTeams: team.teamBaseSpecialTeams,
    teamRoster: team.teamRoster,
    schedule: team.schedule,
    scheduleByYear: team.scheduleByYear,
    rivalries: team.rivalries || [],
  };
};

export const teamDetailsConverter: FirestoreDataConverter<ITeamDetails> = {
  toFirestore(team: ITeamDetails): DocumentData {
    return teamDetailsToDoc(team);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): ITeamDetails {
    const team = docSnap.data(options);

    return {
      teamID: team.teamID,
      teamAbrv: team.teamAbrv,
      teamName: team.teamName,
      teamFullName: team.teamFullName,
      teamLogo: team.teamLogo,
      teamColor: team.teamColor,
      teamSecondaryColor: team.teamSecondaryColor,
      teamConference: team.teamConference,
      teamDivision: team.teamDivision,
      teamCity: team.teamCity,
      teamState: team.teamState,
      teamStadium: team.teamStadium,
      teamCapacity: team.teamCapacity,
      teamStadiumFieldType: team.teamStadiumFieldType,
      teamStadiumHasRoof: team.teamStadiumHasRoof,
      teamHeadCoach: team.teamHeadCoach,
      teamOffensiveCoordinator: team.teamOffensiveCoordinator,
      teamDefensiveCoordinator: team.teamDefensiveCoordinator,
      teamSpecialTeamsCoach: team.teamSpecialTeamsCoach,
      teamOffensiveScheme: team.teamOffensiveScheme,
      teamDefensiveScheme: team.teamDefensiveScheme,
      teamBaseFormation: team.teamBaseFormation,
      teamBaseDefense: team.teamBaseDefense,
      teamBaseOffense: team.teamBaseOffense,
      teamBaseSpecialTeams: team.teamBaseSpecialTeams,
      teamRoster: team.teamRoster,
      schedule: team.schedule,
      scheduleByYear: team.scheduleByYear,
      rivalries: team.rivalries || [],
    };
  },
};
// #endregion
